// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import Component from "@/routes/company/_layout/inventory/non-medical-master/-components/component";
import { SearchParams } from "@/routes/company/_layout/inventory/non-medical-master/-data/model";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/company/_layout/inventory/non-medical-master/")({
    component: Component,
    validateSearch: SearchParams,
});